import { render, staticRenderFns } from "./markdown.vue?vue&type=template&id=b709a36e&"
import script from "./markdown.vue?vue&type=script&lang=js&"
export * from "./markdown.vue?vue&type=script&lang=js&"
import style0 from "./markdown.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports